import { IconButton } from "@mui/material";
import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 5px;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		min-width: 500px;
	}
`;

export const RowItem = styled.div`
	width: 100%;
	gap: 15px;
	display: grid;
	grid-template-columns: 35px 1fr;
	grid-template-rows: 1fr;
	grid-column-gap: 10px;
	grid-row-gap: 0px;
`;

export const PositionList = styled.span`
	display: flex;
	align-items: center;
	color: ${({ theme }) => theme.pantoneBlack};
	font-weight: bold;
	text-align: left;
`;

export const Item = styled.div`
	position: relative;
	border-radius: 5px;
	width: 100%;
	height: 50px;
	margin: 0;
	border: 1px solid ${({ theme }) => theme.pantoneBlack};
	display: grid;
	grid-template-columns: 1fr 0.06fr;
	grid-template-rows: 1fr;
	grid-column-gap: 10px;
	padding: 0 20px 0 0;
`;

export const ItemGrab = styled.div`
	display: grid;
	grid-template-columns: 0.55fr 1fr 0.7fr;
	grid-template-rows: 1fr;
	grid-column-gap: 10px;
	grid-row-gap: 0px;
	align-items: center;
	padding-left: 40px;
	cursor: grab;
`;

export const AreaButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: end;
	text-align: right;
`;

export const Title = styled.p`
	margin: 0;
	color: ${({ theme }) => theme.pantoneBlack};
	font-weight: bold;
	text-align: left;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
`;

export const Text = styled.p`
	margin: 0;
	text-align: center;
	color: #8d8d8d;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
`;

export const ButtonEditIcon = styled(IconButton)`
	&&& {
		color: ${({ theme }) => theme.pantoneBlack};
	}
`;

export const ButtonCloseIcon = styled(IconButton)`
	&&& {
		color: ${({ theme }) => theme.red};
	}
`;
